/**
 * SEO-friendly URL slug helpers for landing pages.
 *
 * Categories use Lithuanian-rooted slugs (better for `naudoti irankiai Vilniuje`
 * type queries) instead of the internal English keys ("tools", "auto_parts").
 *
 * Cities are turned into ASCII-lowercase by stripping diacritics so that
 * `Šiauliai` becomes `siauliai`. Round-trips through `cityFromSlug` rebuild
 * the canonical case by matching against the canonical city list.
 */
import { normalize } from "./textNormalize";

// Slug ↔ category key (the key is what we send to /api/listings).
export const CATEGORY_SLUGS = {
  irankiai: "tools",
  "auto-detales": "auto_parts",
  sodas: "garden",
  buitis: "household",
  apranga: "clothing",
  elektronika: "electronics",
  sportas: "sports",
  vaikams: "kids",
  statyba: "construction",
  "statybines-medziagos": "construction_materials",
  zaidimai: "video_games",
  kita: "other",
};

export const SLUG_BY_CATEGORY = Object.fromEntries(
  Object.entries(CATEGORY_SLUGS).map(([slug, key]) => [key, slug])
);

export function categoryFromSlug(slug) {
  if (!slug) return null;
  return CATEGORY_SLUGS[slug.toLowerCase()] || null;
}

export function slugForCategory(key) {
  return SLUG_BY_CATEGORY[key] || null;
}

/**
 * `Šiauliai` → `siauliai`. Replaces any whitespace with `-` so multi-word
 * cities like `Naujoji Akmenė` become `naujoji-akmene`.
 */
export function citySlug(name) {
  if (!name) return "";
  return normalize(name).replace(/\s+/g, "-");
}

/**
 * Resolve a slug back to the canonical city name by scanning a list of
 * cities passed in from the backend (`/api/cities`). Returns `null` if no
 * match — caller should 404 in that case.
 */
export function cityFromSlug(slug, cities) {
  if (!slug || !cities) return null;
  const target = slug.toLowerCase();
  return cities.find((c) => citySlug(c) === target) || null;
}
